import { render, staticRenderFns } from "./Item-cart.vue?vue&type=template&id=4876a5ce&scoped=true&lang=pug"
import script from "./Item-cart.vue?vue&type=script&lang=js"
export * from "./Item-cart.vue?vue&type=script&lang=js"
import style0 from "./Item-cart.vue?vue&type=style&index=0&id=4876a5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4876a5ce",
  null
  
)

export default component.exports